import { addMonths, format } from 'date-fns';
const today = new Date();
const initialShippingOptions = {
  collectionPointDelivery: [
    {
      carrierGroupKey: 'hermes',
      carrierKey: 'HERMES_KLV',
      collectionPointType: 'hermes_parcelshop',
      deliveryOptionKey: 'collection_points',
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'collection_point_delivery',
      isDisabled: false
    },
    {
      carrierGroupKey: 'dhl',
      carrierKey: 'DHL_STD_NATIONAL',
      collectionPointType: 'dhl_packstation',
      deliveryOptionKey: 'collection_points',
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'collection_point_delivery',
      isDisabled: false
    },
    {
      carrierGroupKey: 'dhl',
      carrierKey: 'DHL_STD_NATIONAL',
      collectionPointType: 'dhl_postoffice',
      deliveryOptionKey: 'collection_points',
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'collection_point_delivery',
      isDisabled: false
    },
    {
      carrierGroupKey: 'blabla',
      carrierKey: 'BLABLA',
      collectionPointType: 'generic',
      deliveryOptionKey: 'click_and_collect',
      shippingOptionKey: 'standard_delivery',
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      isDisabled: false
    }
  ],
  homeDelivery: [
    {
      carrierGroupKey: 'dhl',
      carrierKey: 'DHL',
      deliveryOptionKey: 'home_delivery',
      deliveryEstimations: {
        deliveryDateTime: {
          iso8601: '2021-04-23T14:00:00+01:00'
        },
        deliveryDays: {
          maximum: 3,
          minimum: 2
        }
      },
      isDisabled: false,
      requiresDateSchedule: false,
      requiresTimeSchedule: false,
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'de_dhl_standard'
    },
    {
      carrierGroupKey: 'dhl',
      carrierKey: 'DHL',
      deliveryOptionKey: 'home_delivery',
      deliveryEstimations: {
        deliveryDateTime: {
          iso8601: '2021-04-22T14:00:00+01:00'
        },
        deliveryDays: {
          maximum: 2,
          minimum: 1
        }
      },
      isDisabled: false,
      requiresDateSchedule: false,
      requiresTimeSchedule: false,
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 794
      },
      shippingOptionKey: 'de_dhl_express'
    },

    {
      carrierGroupKey: 'hermes',
      carrierKey: 'HERMES_STD_NATIONAL',
      deliveryOptionKey: 'home_delivery',
      deliveryEstimations: {
        deliveryDateTime: {
          iso8601: '2021-04-23T14:00:00+01:00'
        },
        deliveryDays: {
          maximum: 3,
          minimum: 2
        }
      },
      isDisabled: false,
      requiresDateSchedule: false,
      requiresTimeSchedule: false,
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'least_packages'
    },

    {
      carrierGroupKey: 'hermes',
      carrierKey: 'HERMES_STD_NATIONAL',
      deliveryOptionKey: 'home_delivery',
      deliveryDates: {
        minimum: format(today, 'yyyy-MM-dd'),
        maximum: format(addMonths(today, 4), 'yyyy-MM-dd')
      },
      isDisabled: false,
      requiresDateSchedule: true,
      requiresTimeSchedule: false,
      serviceCosts: {
        taxAmount: 0,
        taxRate: 0,
        withoutTax: 0,
        withTax: 0
      },
      shippingOptionKey: 'scheduled_delivery'
    }
  ]
};

export default initialShippingOptions;
